import { SimpleGrid, Flex } from '@chakra-ui/react';
import React from 'react';

import { days } from 'global/options';
interface IDayPickerProps {
  value: Array<any>;
  handleChange: (value: any) => void;
}

const DayPicker: React.FC<IDayPickerProps> = ({ value, handleChange }) => {
  return (
    <SimpleGrid columns={7} borderColor="primary.500" border="1px solid" borderRadius="lg" overflow="hidden">
      {days.map((day: any) => (
        <Flex
          key={day.value}
          justifyContent="center"
          alignItems="center"
          borderRight="1px"
          p="2"
          fontSize="sm"
          sx={{ '&:last-of-type': { borderRight: 0 } }}
          cursor="pointer"
          _hover={{ background: 'primary.500', color: 'white' }}
          background={value.findIndex(selectedDay => selectedDay.value === day.value) !== -1 ? 'primary.500' : 'white'}
          color={value.findIndex(selectedDay => selectedDay.value === day.value) !== -1 ? 'white' : 'primary.500'}
          onClick={() => handleChange(day)}
        >
          {day.label}
        </Flex>
      ))}
    </SimpleGrid>
  );
};

export default DayPicker;
